import React from "react";
import { Link } from "react-router-dom";
import { FiX } from "react-icons/fi";
import logo from "../images/Nkenne Ai-01 2.png";
import { menuItems } from "../config/webSiteNavigation.config";
import { DOMAIN_CONFIG, getPortalUrl } from "../config/domains";

const MobileNav = ({ location, toggleMenu }) => {
  // On static site, auth links should point to portal domain
  const loginUrl = DOMAIN_CONFIG.IS_STATIC_SITE ? getPortalUrl('/login') : '/login';
  const signupUrl = DOMAIN_CONFIG.IS_STATIC_SITE ? getPortalUrl('/signup') : '/signup';

  return (
    <div className="absolute top-0 left-0 w-full h-screen bg-white flex flex-col items-center pt-10 space-y-6 text-lg md:hidden">
      {/* Logo inside mobile menu */}
      <div className="absolute top-4 left-4">
        <Link to="/">
          <img src={logo} alt="NKENNE Ai Logo" className="h-10" />
        </Link>
      </div>

      {/* Close button */}
      <button className="absolute top-0 right-6" onClick={toggleMenu}>
        <FiX size={28} />
      </button>

      <div className="mt-16 flex flex-col w-full text-left ml-8">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`block w-full py-3 border-b border-t ${
              location.pathname === item.path ? "text-secondary underline" : ""
            }`}
            onClick={toggleMenu}
          >
            {item.label}
          </Link>
        ))}
      </div>
      
      {/* Login and Signup buttons */}
      {console.log(DOMAIN_CONFIG,"DOMAIN_CONFIG")}
      <div className="flex flex-col space-y-3 w-full px-8 mt-6">
        {DOMAIN_CONFIG.IS_STATIC_SITE ? (
          <>
            <a
              href={loginUrl}
              className="bg-white text-black border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 text-center"
              onClick={toggleMenu}
            >
              Login
            </a>
            <a
              href={signupUrl}
              className="bg-[#1E6C56] text-white px-4 py-2 rounded-lg hover:bg-primary-dark text-center"
              onClick={toggleMenu}
            >
              Signup
            </a>
          </>
        ) : (
          <>
            <Link
              to="/login"
              className="bg-white text-black border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 text-center"
              onClick={toggleMenu}
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="bg-[#1E6C56] text-white px-4 py-2 rounded-lg hover:bg-primary-dark text-center"
              onClick={toggleMenu}
            >
              Signup
            </Link>
          </>
        )}
        <Link
          to="https://www.nkenne.com"
          target="_blank"
          className="bg-[#1E6C56] text-white px-4 py-2 rounded-lg hover:bg-primary-dark text-center"
          onClick={toggleMenu}
        >
          Try NKENNE app
        </Link>
      </div>
    </div>
  );
};

export default MobileNav;
